import {observer} from 'mobx-react-lite';
import React, {useState} from 'react';
import {FileSelectorState} from './FileSelector.state';
import { Description, FolderPlusIconWrapper, Wrapper } from 'src/components/Uploader/Uploader.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';

interface PropsType {
    onAccept: (files: File[]) => Promise<void>,
    label: string,
    maxFileSize?: number,
    hideMaxSizeInfo?: boolean;
    allowedFileTypes: string[]
}

export const FileSelector = observer((props: PropsType)=>{
    const {onAccept, label, maxFileSize, allowedFileTypes, hideMaxSizeInfo} = props;

    const [ state ] = useState(() => new FileSelectorState(onAccept, maxFileSize, allowedFileTypes));

    return (
        <Wrapper hideMaxSizeInfo={hideMaxSizeInfo}>
            <Button onClick={state.handleClick}>
                <FolderPlusIconWrapper /> {label}
            </Button>
            {hideMaxSizeInfo === true ? null :
                <Description>{`(Maximum total file size: ${state.maxFileSizeMb} MB)`}</Description>
            }
        </Wrapper>
    );
});

